import { MainContainer } from "components/common";
import { useEffect } from "react";
import {
  MainRewards,
  RewardsHeading,
  RewardsTable,
  RowDivider,
  TableDiv,
  TransactionHeader,
} from "./element";
import trophy from "../../assets/trophy.png";
import { CommonUtility, shareholders } from "utility";
import { useAppSelector } from "store/store";
import { paymentList } from "components/data/selectData";

function RewardsCom({ data }: { data: any }) {
  const handleAmount = (detail, value) => {
    const paymentTokens = paymentList(`${detail?.network}`);
    const erc20Token = paymentTokens.find(
      (x) => x.value.toLocaleLowerCase() === detail?.signed_order.erc20Token
    );
    return CommonUtility.handleDivDecimals(value, erc20Token.decimals, 8);
  };

  const tokenInfo = (detail) => {
    const paymentTokens = paymentList(`${detail?.network}`);
    const erc20Token = paymentTokens.find(
      (x) => x.value.toLocaleLowerCase() === detail?.signed_order.erc20Token
    );
    return erc20Token.text;
  };

  return (
    <MainRewards>
      <MainContainer>
        <TableDiv>
          <RewardsHeading>
            <img className="img-fluid" alt="" src={trophy} />
            Rewards
          </RewardsHeading>

          <RewardsTable
            responsive
            style={{
              textAlign: "center",
            }}
          >
            <thead>
              <tr>
                <th style={{ minWidth: "150px" }}>Date</th>
                <th style={{ minWidth: "150px" }}>Nft Contract Address</th>
                <th style={{ minWidth: "150px" }}>Nft id</th>
                <th style={{ minWidth: "150px" }}>Token</th>
                <th style={{ minWidth: "150px" }}>Amount </th>
                <th style={{ minWidth: "150px" }}>From</th>
              </tr>
            </thead>

            <tbody>
              {data &&
                data.length > 0 &&
                data.map((item) => {
                  const amount = item.recipients.find(
                    (x) => x.name === shareholders.REFERRER
                  ).amount;
                  return (
                    <>
                      <tr>
                        <td>{CommonUtility.mm_dd_yy(item.updatedAt)}</td>
                        <td>
                          {" "}
                          {CommonUtility.addressConvertor(
                            CommonUtility.deStructureNftId(item.nft_id)
                              .tokenAddress
                          )}
                        </td>
                        <td style={{ maxWidth: "10px" }}>
                          {CommonUtility.deStructureNftId(item.nft_id).tokenId}
                        </td>
                        <td>{tokenInfo(item.sell_nft)}</td>
                        <td>{handleAmount(item.sell_nft, amount)}</td>
                        <td>
                          {CommonUtility.addressConvertor(
                            item.sell_nft.wallet_address
                          )}
                        </td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </RewardsTable>
        </TableDiv>
      </MainContainer>
    </MainRewards>
  );
}

export default RewardsCom;
